package dev.lingvo.site.components.studio.compose

import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlin.coroutines.suspendCoroutine

/** Browser zlib compression, with the portable stored-block encoder on older browsers. */
object BrowserDeflate : Deflate {
    /** Large RGB exports require native compression to stay below the store byte cap. */
    val available: Boolean get() = js("typeof CompressionStream === 'function' && typeof Response === 'function' && typeof Blob === 'function'") as Boolean

    override suspend fun compress(input: ByteArray): ByteArray {
        if (!available) return StoredDeflate.compressStored(input)
        val bytes: dynamic = input
        val compressBytes: dynamic = js("(function(bytes) { return new Response(new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate'))).arrayBuffer(); })")
        return suspendCoroutine { continuation ->
            try {
                compressBytes(bytes).then(
                    { buffer: dynamic ->
                        try {
                            continuation.resume(js("new Int8Array(buffer)").unsafeCast<ByteArray>())
                        } catch (error: Throwable) {
                            continuation.resumeWithException(error)
                        }
                    },
                    { _: dynamic -> continuation.resume(StoredDeflate.compressStored(input)) },
                )
            } catch (_: Throwable) {
                continuation.resume(StoredDeflate.compressStored(input))
            }
        }
    }
}
